module.exports = function() {
  return {
    $get: ['$translate',
      function($translate) {
        /* --------------------email--------------------- */
        // const basePattern = '~`!@#\\$%\\^&\\*\\(\\)=\\+\\{\\}\\[\\]\\|\\\\";:<>,\\?\\/' +
        // '\\u007e\\uff01\\u002b\\u0023\\uffe5\\u0025\\u2026\\u002a\\uff08\\u003d\\uff09\\u2014\\u007b\\u007d\\u007c\\u3010' +
        // '\\u3011\\u3001\\uff1a\\uff1b\\u2018\\u2019\\u300a\\u300b\\uff1f\\uff0c\\u3002\\u201c\\u201d\\u0026'
        // var LOCAL_PART = "[^" + basePattern + "\\-'\\.][^" + basePattern + "]*(?:\\.[^" + basePattern + "\\-'\\.][^" + basePattern + "]*)*";
        // var HOST = "[^" + basePattern + "\\-]([^" + basePattern + "]*[^" + basePattern + "\\-])?(?:\\.[^" + basePattern + "\\-]([^" + basePattern + "]*[^" + basePattern + "\\-])?)+$";

        // var LOCAL_PART = "([\\w\\u4E00-\\u9FA5\\uF900-\\uFA2D!#$%&'*+-/=?\\^_`{|}~\\.]+)";
        // var HOST = "([-\\w\\u4E00-\\u9FA5\\uF900-\\uFA2D]+(\\.[-\\w\\u4E00-\\u9FA5\\uF900-\\uFA2D]+)+)";

        // const LOCAL_PART = '([\\.\\w\\u4e00-\\u9fa5]*)'
        const LOCAL_PART = '(.*)'
        const HOST = '([-\\w\\u4e00-\\u9fa5]+(\\.[-\\w\\u4e00-\\u9fa5]+)+)'

        const EMAIL_PATTERN = LOCAL_PART + '@' + HOST
        const patternStrs = [
          // "Changzhen Guo" <bineon@yahoo.com>
          '\\"(.+)\\"[ ]*<' + EMAIL_PATTERN + '>',
          // 'Changzhen Guo' <bineon@yahoo.com>
          "\\'(.+)\\'[ ]*<" + EMAIL_PATTERN + '>',
          // Changzhen Guo <bineon@yahoo.com>
          "([^\"']+)<" + EMAIL_PATTERN + '>',
          // <bineon@yahoo.com>
          '<' + EMAIL_PATTERN + '>',
          // "bineon@yahoo.com"
          '\\"' + EMAIL_PATTERN + '\\"',
          // 'bineon@yahoo.com'
          "\\'" + EMAIL_PATTERN + "\\'",
          // bineon@yahoo.com
          EMAIL_PATTERN,

          // 手机客户端中发现的badcase, add by lijiawen
          // "Changzhen Guo" < bineon@yahoo.com >
          "[ \\\"\\']?(.+)[ \\\"\\']?[ ]*<[ ]*" + EMAIL_PATTERN + '[ ]*>'
        ]

        const email = {

          /**
           * 校验给定Email地址是否合法
           * @param  {string} string
           * @return {boolean}
           */
          test: function(string) {
            for (let i = 0; i < patternStrs.length; i++) {
              const pieces = string.match(patternStrs[i])
              if (pieces != null) {
                return true
              }
            }
            return false
          },

          parseList: function(str) {
            const emails = []
            let remaining = str.trim()
            const MAX_EMAIL_LENGTH = 256 // 防止超长字符串导致性能问题

            while (remaining.length > 0) {
              let maxLen = 0
              let bestMatch = null

              // 从最长子串开始尝试匹配（限制最大长度）
              for (let len = Math.min(remaining.length, MAX_EMAIL_LENGTH); len > 0; len--) {
                const candidate = remaining.substring(0, len)

                // 特殊处理空地址情况
                if (candidate.trim().endsWith('<>')) {
                  const nameMatch = candidate.match(/["']?(.+?)["']?\s*<>/)
                  emails.push({
                    addr: '',
                    name: nameMatch ? nameMatch[1].replace(/["']/g, '') : '',
                    domain: undefined
                  })
                  remaining = remaining.substring(len).replace(/^\s*[,;]\s*/, '').trim()
                  continue
                }

                if (this.test(candidate)) {
                  maxLen = len
                  bestMatch = candidate
                  break
                }
              }

              if (bestMatch) {
                const parsed = this.parse(bestMatch, false)
                emails.push(parsed)
                remaining = remaining.substring(maxLen)
                  .replace(/^\s*[,;]\s*/, '').trim()
              } else {
                // 处理无效内容
                const separatorIndex = remaining.search(/[,;]/)
                if (separatorIndex === -1) {
                  emails.push({ addr: remaining.trim(), name: '', domain: '' })
                  remaining = ''
                } else {
                  const invalidPart = remaining.substring(0, separatorIndex).trim()
                  if (invalidPart) {
                    emails.push({ addr: invalidPart, name: '', domain: '' })
                  }
                  remaining = remaining.substring(separatorIndex + 1).trim()
                }
              }
            }

            return emails
          },

          /**
           * 解析Email地址
           * 为了兼容原来的逻辑，增加了一个参数 extractNameFromLocalPart，表示是否从 local part 提取名字，默认 true
           * @param  {null} string
           * @param  {boolean} extractNameFromLocalPart
           * @return {object}
           */
          parse: function(string, extractNameFromLocalPart) {
            if (extractNameFromLocalPart === undefined) {
              extractNameFromLocalPart = true
            }
            const e = {}
            for (let i = 0; i < patternStrs.length; i++) {
              const p = patternStrs[i]
              const pieces = string.match(p)

              if (pieces == null) {
                continue
              }
              if (pieces.length == 5) {
                // 去掉引号
                e.name = pieces[1].replace(/"/g, '')
                e.addr = pieces[2] + '@' + pieces[3]
                e.domain = pieces[3]
                return e
              } else if (pieces.length == 4) {
                // 去掉引号
                e.name = extractNameFromLocalPart ? pieces[1].replace(/"/g, '') : ''
                e.addr = pieces[1] + '@' + pieces[2]
                e.domain = pieces[2]
                return e
              } else {
                e.addr = string
                return e
              }
            }
            e.addr = string
            return e
          },
          parseTrueName: function (email) {
            if (!email) {
              return ''
            }
            const arrPos = email.lastIndexOf('<')
            if (arrPos > -1) {
              email = trim(email.substr(0, arrPos)) // temp = ""测\"试""
              email = email.replace(/^["']/, '').replace(/["']$/, '')
              return email.replace(/\\"/g, '"').replace(/\\\\/g, '\\')
            }
            return ''
          },
          validate: function (email) {
            // http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
            // var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const emailRE = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/ //eslint-disable-line
            return emailRE.test(email)
          },
          parseMid(mid = '') {
            const arr = mid.split(':')
            return arr.length > 1 ? arr[1] : arr[0]
          },
          getUid(email = '') {
            const arr = email.split('@')
            return arr[0]
          },
          toString: function(emailObj) {
            // 处理空值情况
            if (!emailObj || typeof emailObj !== 'object') return ''

            const { name = '', addr = '' } = emailObj

            // 空地址特殊处理 (如："Name" <>)
            if (!addr && name) {
              return `"${name.replace(/"/g, '\\"')}" <>`
            }

            // 纯地址情况 (如：test@example.com)
            if (!name) return addr

            // 标准带姓名格式 (如："Name" <test@example.com>)
            return `"${name.replace(/"/g, '\\"')}" <${addr}>`
          }
        }

        function trim(str) {
          // native trim is way faster: http://jsperf.com/angular-trim-test
          // but IE doesn't have it... :-(
          // TODO: we should move this into IE/ES5 polyfill
          if (!String.prototype.trim) {
            return (typeof str === 'string') ? str.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : str
          }

          return (typeof str === 'string') ? str.trim() : str
        }

        return email
      }]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/email.js